import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormHelperText from '@material-ui/core/FormHelperText';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import Select from '../../../components/SimpleSelect/Select';
import {ESPECIALIDADITEMS} from '../../../utils/ConstantsMain';
import ComboText from '../../../components/ComboText';
import Autocomplete from '@material-ui/lab/Autocomplete';



const styles = () => ({
  colorActiveCheck: {
      color: '#094565',
      fontSize: 12,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    margin: 0,
    paddingLeft: 0
    },
  colorActiveLabel: {
    '&:hover': {
      color: '#094565'
    },
    color: '#c1c1c1',
    fontSize: 12,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    margin: 0,
    paddingLeft: 0
  },
  labelTermino: {
    fontWeight: '400'
  },
  FormControlLabelRoot: {
    margin: 0
  },
  checkPadding: {
    padding: '0',
    marginRight: 4,
  },
  IconButtonRoot: {
    color: '#c1c1c1',
    padding: 5
  },
  linkTerms: {
    textDecoration: 'none',
    color: 'inherit'
  }
});

const SignUpForm = props => {
  const {
    // dirty,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
    setFieldTouched
  } = props;



  const [showPassword, setShowPassword] = useState(false);

  const handleTagSelect = field => value => {
    setFieldValue(field, value);
  };


  const handleTagSelectSingle = (value, field) => {
    if(value == null) value = ''
    setFieldValue(field, value);
  };

  

  return (
    <form>
      <Grid container direction="column" justify="center" alignItems="center">
        <TextField
          label="Correo electrónico"
          id="email"
          type="email"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
        />

        <TextField
          label="Contraseña"
          id="password"
          type={showPassword ? 'text' : 'password'}
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.password}
          helperText={
            touched.password && errors.password ? errors.password : ''
          }
          error={touched.password && errors.password ? true : false}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  classes={{
                    root: classes.IconButtonRoot
                  }}
                  aria-label="Toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

   
  <div style={{    width: '100%', maxWidth: '304px'}}>

  


      <Autocomplete
        getOptionLabel={option => option }
        multiple={false}
        value={values.specialties? values.specialties:''}
        id={'specialties'}
        options={ESPECIALIDADITEMS}
        filterSelectedOptions
        disableCloseOnSelect={false}
        blurOnSelect ={true}
        onChange={(event, value) => {
          handleTagSelectSingle(value,'specialties')
        }} 
        size={'small'}
       
        renderInput={params => (<TextField
          type="text"
        classes={{root: classes.root}}
        onBlur={handleBlur}

          helperText={touched.specialties && errors.specialties ? errors.specialties : ''}
          error={touched.specialties && errors.specialties && touched.specialties ? true : false}
          
          {...params}
          label={'Especialidad'}
          variant="outlined"
          
          //value={value}
        />
        )

        }
      />
        

  </div>
 
       
         <TextField
          label="Teléfono"
          id="phone"
          type="tel"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.phone}
          helperText={
            touched.phone && errors.phone && touched.phone ? errors.phone : ''
          }
          error={touched.phone && errors.phone && touched.phone ? true : false}
          fullWidth
        />
        <div style={{width: 296}}>
        <FormControlLabel
          classes={{
            root: classes.FormControlLabelRoot
          }}
          control={
            <Checkbox
              name="termsAndConditions"
              id="termsAndConditions"
              checked={values.termsAndConditions}
              onChange={event => {
                handleChange(event);
                handleBlur(event);
              }}
              onBlur={handleBlur}
              value="checked"
              color="secondary"
              label="Gilad Gray"
              classes={{
                root: classes.checkPadding
              }}
            />
          }
          label={
            <>
              <p className={values.termsAndConditions ? classes.colorActiveCheck: classes.colorActiveLabel}>
                <span className={classes.labelTermino}>Acepto los</span> <a className={classes.linkTerms} href="/informacion-adicional" target="_blank">Términos y
                condiciones</a> y la <a className={classes.linkTerms} href="/informacion-adicional" target="_blank">Política de
                privacidad</a> de Contacta Abogado
              </p>
              {touched.termsAndConditions && errors.termsAndConditions && (
                <FormHelperText error>
                  {errors.termsAndConditions}
                </FormHelperText>
              )}
            </>
          }
        />
        </div>
      </Grid>

      <div className="horizontal-layout" style={{ marginTop: 36 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
        >
          Continuar
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(SignUpForm);
